import { Button, Layout, Menu, Modal, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router';
import ActionHeader from '../../../components/actionHeader';
import Page from '../../../components/page';
import {
  fetchMachineById,
  selectIsFetchingMachine,
  selectMachine,
} from '../../../slices/machines';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store';
import { StyledContent, StyledMenu } from './styles';
import { deleteMachine } from '../../../utils/httpRequest';

export const menus = [
  {
    key: '',
    label: 'Details',
  },
  {
    key: 'solutionGrid',
    label: 'Solution Grid',
  },
  {
    key: 'issue',
    label: 'Issue',
  },
  {
    key: 'cause',
    label: 'Cause',
  },
  {
    key: 'routine',
    label: 'Routine',
  },
  {
    key: 'resourceLibrary',
    label: 'Resource Library',
  },
];

const MachineDetailsContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id = '' } = useParams();

  const machine = useSelector(selectMachine);
  const isFetchingMachine = useSelector(selectIsFetchingMachine);

  const { pathname } = location;

  const selectedKeys = pathname.split('/').slice(4);

  const [defaultOpenKeys, setDefaultOpenKeys] = useState<string[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setShowDeleteModal(false);
      setLoading(true);
      await deleteMachine(id);
      navigate('/knowledge/machine');
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(fetchMachineById(id));
  }, []);

  return (
    <Page
      backgroundColor="#fff"
      gap={0}
      header={
        <ActionHeader
          title={machine?.name}
          showBack
          onBack={() => navigate(-1)}
          endSlot={
            <>
              <Button
                type="primary"
                danger
                ghost
                onClick={() => setShowDeleteModal(true)}
              >
                Delete
              </Button>
              <Button type="primary" ghost onClick={() => navigate('edit')}>
                Edit
              </Button>
            </>
          }
        />
      }
    >
      <Spin spinning={isFetchingMachine || loading} fullscreen>
        {' '}
        {loading && 'Deleting...'}
      </Spin>
      <Layout style={{ height: '100%' }}>
        <Layout.Sider style={{ backgroundColor: '#f7f7f7' }} width={144}>
          <StyledMenu
            selectedKeys={selectedKeys[0] ? selectedKeys : ['']}
            defaultOpenKeys={defaultOpenKeys}
            theme="light"
            items={menus}
            onClick={({ key, keyPath }) => {
              navigate(key, { replace: true });
              setDefaultOpenKeys(keyPath);
            }}
          />
        </Layout.Sider>
        <StyledContent>
          <Outlet />
        </StyledContent>
        <Modal
          title={`Delete ${machine?.name}`}
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={showDeleteModal}
          onOk={handleDelete}
          onCancel={() => setShowDeleteModal(false)}
        >
          <p>Are you sure to delete {machine?.name}?</p>
        </Modal>
      </Layout>
    </Page>
  );
};

export default MachineDetailsContainer;
